import React from 'react';
import {Redirect, Route, Switch,asyncComponent} from '../../../components';
const Customers = ({match}) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/all`} component={asyncComponent(() => import('./routes/list'))}/>
      <Route path={`${match.url}/add-payment`} component={asyncComponent(() => import('./routes/add'))}/>
      <Route path={`${match.url}/report`} component={asyncComponent(() => import('./routes/report'))}/>
      <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Customers;
